import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants/index';

import { viewReducerMerger, viewReducerRemover } from '../helpers/views';

export const DEFAULT_STATE = Map({
	page: 0,
	hasMore: false,
	next: null,
});

const featuredTopics = viewReducerMerger(
	[Constants.FETCH_FEATURED_TOPICS, Constants.FETCH_MORE_FEATURED_TOPICS],
	'topics',
);

const deletedFeaturedTopics = viewReducerRemover([Constants.DELETE_TOPIC, Constants.UPDATE_TOPIC]);

export default reducerChain([featuredTopics, deletedFeaturedTopics], DEFAULT_STATE);
